// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { GradientPage } from '../../components/common';
import { PageTitle } from '../../components/signUp';
import I18n from '../../lib/i18n';
import { ResetPasswordForm } from './components/ResetPasswordForm';

class ResetPassword extends PureComponent<{}, void> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <GradientPage>
        <PageTitle title={I18n.t('resetPassword')} />
        <View style={styles.form}>
          <ResetPasswordForm />
        </View>
      </GradientPage>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    form: {
      marginTop: 15,
      marginHorizontal: 17,
    },
  });

export default ResetPassword;
